import CopyButton from 'components/reusable/CopyButton'
import { type CombinedInvoice, isEmployerInvoice, isStripeInvoice } from 'utils/billing'

import { EmployerInvoiceDropdown } from './EmployerInvoiceDropdown'
import { StripeInvoiceDropdown } from './StripeInvoiceDropdown'

interface BillingBreakdownHeaderProps {
  titleText: string
  subheaderText: string
  invoiceNumber: string
  invoice: CombinedInvoice
  showPlanYear?: boolean
  reportDownloadUrl?: string | null
}

export function BillingBreakdownHeader ({
  titleText,
  subheaderText,
  invoiceNumber,
  invoice,
  showPlanYear,
  reportDownloadUrl,
}: BillingBreakdownHeaderProps) {
  const downloadDropdown = isStripeInvoice(invoice)
    ? (
      <StripeInvoiceDropdown invoicePdf={invoice.invoice_pdf ?? null} />
      )
    : isEmployerInvoice(invoice)
      ? (
        <EmployerInvoiceDropdown
          invoice={invoice}
          showPlanYear={showPlanYear ?? false}
          reportDownloadUrl={reportDownloadUrl}
        />
        )
      : null

  return (
    <>
      <div className='mb-2 flex flex-col gap-4 md:flex-row md:items-center md:justify-between'>
        <h2 className='heading-md'>{titleText}</h2>
        <div className='hidden md:block'>
          {downloadDropdown}
        </div>
      </div>

      <div className='mb-4 md:hidden'>
        <div className='body-sm text-gray-500 mb-4'>
          {subheaderText}
        </div>
        <div className='mb-4'>
          {downloadDropdown}
        </div>
        <div className='flex items-center gap-2'>
          <span className='body-sm text-gray-500'>Invoice #: {invoiceNumber}</span>
          <CopyButton valueToCopy={invoiceNumber} variant='default' />
        </div>
      </div>

      <div className='mb-6 hidden md:flex md:items-center md:justify-between'>
        <div className='body-sm text-gray-500'>
          {subheaderText}
        </div>
        <div className='flex items-center'>
          <span className='body-sm text-gray-500'>Invoice #: {invoiceNumber}</span>
          <CopyButton valueToCopy={invoiceNumber} variant='default' />
        </div>
      </div>
    </>
  )
}
